/* "Great Design Should Be Accessible": swipe slider where the card in the middle is the big, highlighted one.
   Arrows, the bars under the cards, swiping and the keyboard arrow keys all move the same way. */
(function () {
  'use strict';

  function init(root) {
    if (root.__ladder) return;
    root.__ladder = true;

    var track = root.querySelector('[data-ladder-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ladder-item]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-ladder-bar]'));
    var prev = root.querySelector('[data-ladder-prev]');
    var next = root.querySelector('[data-ladder-next]');
    if (!track || items.length === 0) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = -1;
    var ticking = false;

    function centerLeft(i) {
      var it = items[i];
      return it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2;
    }
    function nearest() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function render(i) {
      if (i === current) return;
      current = i;
      items.forEach(function (it, n) { it.classList.toggle('is-center', n === i); });
      bars.forEach(function (b, n) {
        b.classList.toggle('is-active', n === i);
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === items.length - 1;
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(items.length - 1, i));
      track.scrollTo({ left: centerLeft(i), behavior: instant || reduce ? 'auto' : 'smooth' });
      if (instant) render(i);
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; render(nearest()); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    bars.forEach(function (b, n) { b.addEventListener('click', function () { go(n); }); });
    items.forEach(function (it, n) {
      it.addEventListener('focusin', function () { if (n !== current) go(n); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    window.addEventListener('resize', function () { go(current < 0 ? 0 : current, true); });

    go(items.length > 2 ? 1 : 0, true); // starts with the second card in the middle, like the design
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ladder]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
